import {AlertDialog, Button, Tooltip, Typography, useOverlayState} from "@heroui/react";
import {ResetIcon} from "@project/icons-web";

import {DEFAULT_BUILDER_PARAMS} from "../../themes/builder-constants";

import {useThemeBuilder} from "./theme-builder-context";

/* ------------------------------------------------------------------------------------------------
 * ResetButton
 * Resets all theme params to defaults after AlertDialog confirmation.
 * Disabled when params already equal defaults and no keys are locked.
 * ------------------------------------------------------------------------------------------------ */
export function ResetButton() {
  const {lockedKeys, params, resetParams} = useThemeBuilder();
  const modalState = useOverlayState();

  const isDisabled =
    JSON.stringify(params) === JSON.stringify(DEFAULT_BUILDER_PARAMS) && lockedKeys.length === 0;

  const handleConfirm = () => {
    resetParams();
    modalState.close();
  };

  return (
    <>
      <Tooltip closeDelay={0} delay={100}>
        <Tooltip.Trigger>
          <Button
            isIconOnly
            isDisabled={isDisabled}
            size="md"
            variant="tertiary"
            onPress={modalState.open}
          >
            <ResetIcon />
          </Button>
        </Tooltip.Trigger>
        <Tooltip.Content>
          <Tooltip.Arrow />
          <Typography>Reset to defaults</Typography>
        </Tooltip.Content>
      </Tooltip>

      <AlertDialog.Backdrop
        isDismissable
        isOpen={modalState.isOpen}
        onOpenChange={modalState.setOpen}
      >
        <AlertDialog.Container>
          <AlertDialog.Dialog>
            <AlertDialog.CloseTrigger />
            <AlertDialog.Header>
              <AlertDialog.Icon status="default">
                <ResetIcon />
              </AlertDialog.Icon>
              <AlertDialog.Heading>Reset theme to default?</AlertDialog.Heading>
            </AlertDialog.Header>
            <AlertDialog.Body>
              This will restore all theme values to their default settings.
            </AlertDialog.Body>
            <AlertDialog.Footer className="flex-col sm:flex-row">
              <Button
                className="order-2 w-full sm:order-1 sm:w-auto"
                size="md"
                variant="tertiary"
                onPress={modalState.close}
              >
                Cancel
              </Button>
              <Button
                className="order-1 w-full sm:order-2 sm:w-auto"
                size="md"
                onPress={handleConfirm}
              >
                Confirm
              </Button>
            </AlertDialog.Footer>
          </AlertDialog.Dialog>
        </AlertDialog.Container>
      </AlertDialog.Backdrop>
    </>
  );
}
